import numberWithCommas from "./numberWithCommas";

export const numberToPrice = (value: number, decimalPlaces: number = 2): string => {
    const rounded = decimalPlaces === 0 ? Math.round(value) : parseFloat(value.toFixed(decimalPlaces));
    return numberWithCommas(rounded);
};
